export default __webpack_public_path__ + "static/media-bg-89b9e51f32ab3324ae7b1408a0069b4a.jpg";